export default "__VITE_ASSET__BCtQZ9Lv__";